import React, { useState } from 'react'

import { Modal } from 'antd';
import { Link } from 'gatsby'

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import '../../styles/descripcion-imagenes.css'



const Carrusel = ({imgs, english}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    /*const handleOk = () => {
        setIsModalVisible(false);
    };*/

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 0 },
          items: 1,
          paritialVisibilityGutter: 0
        }
    };

    return (
        <div className="contenedor-carrusel" id="carrusel-principal">
            <Carousel
              ssr
              partialVisbile
              showDots
              itemClass="image-item"
              autoPlaySpeed={3000}
              responsive={responsive}
              draggable
            >
                {imgs.map((bloque, index) => (
                    <div key={index}>
                        <img 
                            src={bloque.imagen}
                            alt={bloque.titulo}
                            style={{ maxHeight: '92vh', objectFit: 'cover'}}
                            width="100%"
                        />
                        <div className={`descripcion descripcion-${bloque.direccion}`}>
                            {bloque.descripcion  &&
                                <p className="texto-descripcion">{bloque.descripcion}</p>
                            }
                            {bloque.titulo &&
                                <p className="titulo-descripcion">
                                    {bloque.titulo}
                                </p>
                            }
                            {bloque.enlace &&
                                <Link href={bloque.enlace}>
                                    <button className="btn btn-oscuro">{english ? 'more information' : 'más información'}</button>
                                </Link>
                            }
                        </div>
                        {bloque.video &&
                            <div className="playButtonSection">
                                <button 
                                    onClick={showModal}
                                    className="playButton"
                                >
                                    <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        xmlnsXlink="http://www.w3.org/1999/xlink" 
                                        id="Layer_1" x="0px" y="0px" 
                                        viewBox="0 0 512 512" 
                                        style={{enableBackground: 'new 0 0 512 512'}} 
                                        xmlSpace="preserve" width="150px" height="150px"
                                    >
                                        <g>
                                            <path d="M256,0C114.608,0,0,114.608,0,256s114.608,256,256,256s256-114.608,256-256S397.392,0,256,0z M256,496    C123.664,496,16,388.336,16,256S123.664,16,256,16s240,107.664,240,240S388.336,496,256,496z" data-original="#000000" class="active-path" fill="#FFFFFF"/>
                                        </g>
                                        <g>
                                            <g>
                                                <polygon points="189.776,141.328 189.776,370.992 388.672,256.16   " data-original="#000000" class="active-path" fill="#FFFFFF"/>
                                            </g>
                                        </g>
                                    </svg>    
                                </button>
                            </div>
                        }
                    </div>
                ))}
            </Carousel>
            <Modal 
                title="" 
                closable
                visible={isModalVisible} 
                onCancel={handleCancel}
                cancelText="Cerrar"
                okButtonProps={{ style: { display: 'none' } }}
                maskStyle={{backgroundColor: 'rgba(0, 0, 0, 0.795)'}}
                bodyStyle={{height: '60vh', padding: 0}}
                footer={[]}
                width='80%'
            >
                <iframe className="video" width="560" height="315" src="https://www.youtube.com/embed/H39tUZMGdUs?rel=0&enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </Modal>
        </div>
    )
}

export default Carrusel